import { connect } from 'react-redux'
import Component from './Component'

import componentDidMount from './Handlers/componentWillMount'
import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  activityPagination: state.screens.ProjectView.activityPagination,
  activityFetching: state.screens.ProjectView.activityFetching,
})

const actionCreators = {
  componentDidMount,
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Component)
